import { memo } from "react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useIntercom } from "@/hooks/useIntercom";
import { MessageSquare } from "lucide-react";

interface IntroButtonProps {
  show: boolean;
}

const IntroButton = memo(({ show }: IntroButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openMessenger } = useIntercom();
  
  const goToIntroPage = () => {
    sessionStorage.removeItem("hasVisitedIntro");
    navigate("/intro");
  };

  if (!show) return null;

  return (
    <div className="flex flex-col gap-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 0.5
        }}
      >
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
          <Button 
            variant="outline"
            className="bg-black/70 border border-anzir text-white hover:bg-anzir/20 shadow-lg"
            onClick={goToIntroPage}
          >
            {t('intro.previewButton', '预览引导页')}
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
});

IntroButton.displayName = "IntroButton";

export default IntroButton;
